import { render, staticRenderFns } from "./RelComInfo.vue?vue&type=template&id=7daf7d84&scoped=true&"
import script from "./RelComInfo.vue?vue&type=script&lang=js&"
export * from "./RelComInfo.vue?vue&type=script&lang=js&"
import style0 from "./RelComInfo.vue?vue&type=style&index=0&id=7daf7d84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf7d84",
  null
  
)

export default component.exports